import React from 'react';
import PropTypes from 'prop-types';
import Blob from 'components/shared/Blob';
import Heading from 'components/shared/Heading';
import ButtonText from 'components/shared/ButtonText';
import styles from './error.module.scss';

function TableError(props) {
  return (
    <div className={styles.errorContainer}>
      <Blob />
      <Heading tag="h3" styles={[styles.errorHeading]}>
        {props.message}
      </Heading>
      {props.refetchData && (
        <ButtonText underlined onClick={props.refetchData}>
          {props.refetchMessage}
        </ButtonText>
      )}
    </div>
  );
}

TableError.propTypes = {
  message: PropTypes.string.isRequired,
  refetchData: PropTypes.func.isRequired,
  refetchMessage: PropTypes.string.isRequired
};

export default TableError;
